import React from 'react';
import { createPortal, render } from 'react-dom';

import RootStore from '../../store/RootStore';
import usePortalDom from '../hooks/usePortalDom';

import './Toast.scss';

export interface IToast {
  content: React.ReactNode;
  time?: number;
  rootStore?: RootStore;
  show?: boolean;
}

function Toast(props: IToast) {
  const wrapper = usePortalDom({
    targetClassName: `toast-wrapper`,
    parentElement: window.document.getElementById('root-toast')! as HTMLElement,
  });

  return wrapper
    ? createPortal(
        <div className="toast-wrapper animate__animated animate__fadeIn">
          <div className="toast">{props.content}</div>
        </div>,
        wrapper
      )
    : null;
}

export default Toast;

export const message = (content: React.ReactNode, time: number = 2000) => {
  const wrapper = window.document.getElementById('root-toast')!;
  const div = window.document.createElement('div');
  wrapper.appendChild(div);
  render(<Toast content={content} time={time} show={true} />, div);
  setTimeout(() => {
    wrapper.innerHTML = '';
  }, time);
};
